import { createActionGroup, props } from "@ngrx/store";
import { SalesPerson } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export const DataSalesPersonsActions = createActionGroup({
    source: "Data / Sales Persons",
    events: {
        "Load": props<{ companyId: string }>(),
        "Load Success": props<{ salesPersons: SalesPerson[] }>(),
        "Load Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
